import { Scrollbar, Carousel } from '../core'
import './mobile-card'
import '../plugins/post-share'

$.fn.SingleOpportunity = function() {
  let self = $(this).BlockElement().MobileCard()
  self.viewer_index = undefined
  self.carousel = undefined
  self.scrollbar = undefined

  return function() {
    self.viewer_index = parseInt(self.attr('data-index'), 10)
    requestAnimationFrame(function() {
      self.find('.post-share').each(function() {
        $(this).PostShare()
      })
      self.scrollbar = new Scrollbar(self.find('.opportunity__body'), {
        mobile: false,
        preventWheelPropagation: true,
      })
      self.carousel = new Carousel(self.find('.swiper-container').get(0), {
        slidesPerView: 1,
        resizeObserver: true,
        loop: true,
        pagination: {
          el: self.find('.swiper-pagination').get(0),
          clickable: true,
        },
      }).init()
    })
    return self
  }()
}
